import { useState } from "react";
import ReactPlayer from "react-player/youtube";
import { BasePlayer } from "./BasePlayer";

export const YouTubePlayer = ({playerRef, playing, onProgress, onDuration, onSourceChange, playbackRate, volume, children, youtubeKind = "vod", onYouTubeKindChange, ...sessionProps}) => {
  const [url, setURL] = useState("");
  const [tmpUrl, setTmpUrl] = useState("")
  const [inputError, setInputError] = useState(false)

  const handleVideoLinking = () => {
    const nextUrl = tmpUrl.trim()
    if (!nextUrl || !ReactPlayer.canPlay(nextUrl)) {
      setInputError(true)
      return
    }
    setInputError(false)
    setTmpUrl(nextUrl)
    setURL(nextUrl)
  }

  return (
    <BasePlayer
      {...sessionProps}
      Player={ReactPlayer}
      url={url}
      playerRef={playerRef}
      playing={playing}
      onProgress={onProgress}
      onDuration={onDuration}
      onSourceChange={onSourceChange}
      playbackRate={playbackRate}
      volume={volume}
      videoInput={
        <>
          <label className="source-field source-url">YouTube 影片網址<input aria-label="YouTube 影片網址" value={tmpUrl} onChange={(e) => {setTmpUrl(e.target.value)}} placeholder="影片連結" /></label>
          <label className="source-field">影片類型<select aria-label="YouTube 影片類型" value={youtubeKind} onChange={(e) => onYouTubeKindChange?.(e.target.value)}><option value="vod">一般影片</option><option value="live">直播</option></select></label>
          <button onClick={handleVideoLinking}>連結影片</button>
          {inputError && <span className="video-url-error" role="alert" style={{ color: "#f87171" }}>請輸入可播放的影片連結</span>}
        </>
      }
    >
      {children}
    </BasePlayer>
  );
};
